export default {
  set(state, { data }) {
    state.categories = data;
  },
  show(state, { data }) {
    state.category = data;
  }
}